/* tslint:disable */
/* eslint-disable */
/**
 * esign
 * eSign template authoring and request management service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const EsignCancelledReason = {
    OperatorCancelled: 'operator_cancelled',
    ReferralCancelled: 'referral_cancelled',
    ResidentRefusedToSign: 'resident_refused_to_sign',
    ResidentDischargedBeforeSigning: 'resident_discharged_before_signing',
    ResidentDeceased: 'resident_deceased',
    NeverAdmittedReferralLost: 'never_admitted_referral_lost',
    PaperworkNotNeededReadmit: 'paperwork_not_needed_readmit',
    DuplicateOrSentInError: 'duplicate_or_sent_in_error',
    Other: 'other',
} as const;
export type EsignCancelledReason = typeof EsignCancelledReason[keyof typeof EsignCancelledReason];


export function instanceOfEsignCancelledReason(value: any): boolean {
    for (const key in EsignCancelledReason) {
        if (Object.prototype.hasOwnProperty.call(EsignCancelledReason, key)) {
            if (EsignCancelledReason[key as keyof typeof EsignCancelledReason] === value) {
                return true;
            }
        }
    }
    return false;
}

export function EsignCancelledReasonFromJSON(json: any): EsignCancelledReason {
    return EsignCancelledReasonFromJSONTyped(json, false);
}

export function EsignCancelledReasonFromJSONTyped(json: any, ignoreDiscriminator: boolean): EsignCancelledReason {
    return json as EsignCancelledReason;
}

export function EsignCancelledReasonToJSON(value?: EsignCancelledReason | null): any {
    return value as any;
}

export function EsignCancelledReasonToJSONTyped(value: any, ignoreDiscriminator: boolean): EsignCancelledReason {
    return value as EsignCancelledReason;
}

